import { render, staticRenderFns } from "./OriginalDocumentsPo.vue?vue&type=template&id=73a24ed7&scoped=true"
import script from "./OriginalDocumentsPo.vue?vue&type=script&lang=js"
export * from "./OriginalDocumentsPo.vue?vue&type=script&lang=js"
import style0 from "./OriginalDocumentsPo.vue?vue&type=style&index=0&id=73a24ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a24ed7",
  null
  
)

export default component.exports